export const numSequence = (n: number): Array<number> => {
  return Array(n);
};
